const INTERACTION_ENUMS = {
  global: 'global',
  diagnostic: 'diagnostic',
  governanceProject: 'governance_project',
  thridPartyDiagnostic: 'suppliers',
  privacyByDesign: 'privacy_by_design',
}

const INTERACTION_LABELS = {
  global: 'Todos',
  diagnostic: 'Diagnóstico da Empresa',
  governanceProject: 'Projeto de Governança',
  thridPartyDiagnostic: 'Diagnóstico de Terceiros',
}

const KIND_BASIC_REQUIREMENT = 'Requisitos Fundamentais'

const TRANSLATED_ENUMS = {
  [INTERACTION_ENUMS.global]: INTERACTION_LABELS.global,
  [INTERACTION_ENUMS.diagnostic]: INTERACTION_LABELS.diagnostic,
  [INTERACTION_ENUMS.thridPartyDiagnostic]:
    INTERACTION_LABELS.thridPartyDiagnostic,
  [INTERACTION_ENUMS.governanceProject]: INTERACTION_LABELS.governanceProject,
}

const quizTemplates = {
  KIND_BASIC_REQUIREMENT,
  INTERACTION_ENUMS,
  INTERACTION_LABELS,
  TRANSLATED_ENUMS,
}

export default quizTemplates
